<template>
  <div v-if="authors.length" class="inline-block">
    {{ $texts('author', 'Verfasser') }}:
    <template v-for="(author, i) in authorsMapped" :key="author.tid">
      <span v-if="!showFull && author.abbreviation" :title="author.name">
        {{ author.abbreviation }}
      </span>
      <span v-else>
        {{ author.name }}
      </span>
      <template v-if="i < authors.length - 1">, </template>
    </template>
  </div>
</template>

<script lang="ts" setup>
import type { AuthorFragment } from '#graphql-operations'
import { notNullish } from '@vueuse/core'

const props = defineProps<{
  authors: Array<AuthorFragment | null | undefined>
  showFull?: boolean
}>()

const authorsMapped = computed<AuthorFragment[]>(() =>
  props.authors.filter(notNullish),
)
</script>
